import PropTypes from "prop-types";
import React from "react";
import { components } from "react-select";
import Avatar from "~/components/shared/Avatar";

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const highlightInputMatch = (item, keyword) => {
  if (!item || !keyword) {
    return item;
  }
  if (typeof item !== "string") {
    return item;
  }

  const escapedKeyword = escapeRegExp(keyword);
  const parts = item.split(new RegExp(`(${escapedKeyword})`, "gi"));

  return (
    <div>
      {parts.map((part, index) => {
        const key = `${index}-${part}`;

        return part.toLowerCase() === keyword.toLowerCase() ? (
          <strong key={key}>{part}</strong>
        ) : (
          part
        );
      })}
    </div>
  );
};

const Option = ({ children = null, data = {}, selectProps = {}, ...props }) => {
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
  const { inputValue } = selectProps;

  const newProps = { ...props, innerProps: rest };
  const displayText = inputValue
    ? highlightInputMatch(children, inputValue)
    : children;
  const hasUser = !!data.user;

  return (
    <components.Option
      {...newProps}
      className={hasUser ? "" : "text-break word-break"}
    >
      {hasUser ? (
        <span className="d-flex align-items-center flex-nowrap">
          <span className="flex-shrink-0 mr-2">
            <Avatar
              name={data.user?.name}
              avatar={data.user?.avatar_url}
              sizeType="tiny"
              showTooltip={false}
            />
          </span>
          <span className="min-w-0 text-truncate">{displayText}</span>
        </span>
      ) : (
        displayText
      )}
    </components.Option>
  );
};

Option.propTypes = {
  children: PropTypes.node,
  data: PropTypes.shape({
    user: PropTypes.shape({
      name: PropTypes.string,
      avatar_url: PropTypes.string,
    }),
  }),
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string,
  }),
  innerProps: PropTypes.shape({}),
};

export default Option;
